module.exports = __webpack_public_path__ + "img/error404.197fd792.png";